import { cn } from '@/lib/utils';
import {
	PRONTUARIO_PROFILE_LIST_GROUP_CLASS,
	PRONTUARIO_PROFILE_LIST_LABEL_CLASS,
	PRONTUARIO_PROFILE_LIST_VALUE_CLASS,
} from '../../constants/prontuarioTheme';

export type ProntuarioProfileField = {
	label: string;
	value: string;
	multiline?: boolean;
};

type ProntuarioProfileVariant = 'dark' | 'light';

const FIELD_LIST_THEME = {
	dark: {
		group: PRONTUARIO_PROFILE_LIST_GROUP_CLASS,
		divider: 'border-b border-white/[0.08]',
		label: cn(PRONTUARIO_PROFILE_LIST_LABEL_CLASS, 'font-bold'),
		value: cn(PRONTUARIO_PROFILE_LIST_VALUE_CLASS, 'font-normal'),
	},
	light: {
		group: 'overflow-hidden rounded-xl border border-zinc-300 bg-white shadow-sm',
		divider: 'border-b border-zinc-200',
		label: 'text-[12px] font-bold leading-none text-zinc-700',
		value: 'mt-1.5 text-[14px] font-normal leading-snug text-zinc-500',
	},
} as const satisfies Record<ProntuarioProfileVariant, Record<string, string>>;

type ProntuarioProfileFieldListProps = {
	fields: ProntuarioProfileField[];
	className?: string;
	variant?: ProntuarioProfileVariant;
};

const ProntuarioProfileFieldList = ({
	fields,
	className,
	variant = 'dark',
}: ProntuarioProfileFieldListProps) => {
	const theme = FIELD_LIST_THEME[variant];
	const visibleFields = fields.filter((field) => field.value.trim());

	if (!visibleFields.length) return null;

	return (
		<div className={cn(theme.group, className)}>
			{visibleFields.map((field, index) => (
				<div
					key={`${field.label}-${index}`}
					className={cn(
						'px-4 py-3.5',
						index < visibleFields.length - 1 && theme.divider,
					)}
				>
					<p className={theme.label}>{field.label}</p>
					<p
						className={cn(
							theme.value,
							field.multiline
								? 'whitespace-pre-wrap'
								: 'truncate',
						)}
					>
						{field.value.trim()}
					</p>
				</div>
			))}
		</div>
	);
};

export { ProntuarioProfileFieldList };
